import { GDSBorderWidths } from '@leagueplatform/genesis-core';

export const borderWidths: GDSBorderWidths = {
  thin: 1,
  thick: 2,
  innerFocus: 3,
  outerFocus: 3,
};
